import React from "react";
import { findConstantLabel } from "../../../../constants/utils";
import constant from "../../../../constants/constant";
import moment from "moment";
import atoms from "../../../atoms";
import { InProcessProps, TableData } from "./interface";

const { Search, Table, Pagination, CustomImages } = atoms;

const Index = ({
    setSearch,
    processListing,
    setLimitPerPage,
    setCurrentPage,
    currentPage,
    limit,
}: InProcessProps) => {

    const columns = [
        {
            name: "Product ID",
            selector: (row: TableData) => row.product.product_id_display,
            minWidth: "150px",
        },
        {
            name: "Movement ID",
            selector: (row: TableData) => row.procurement.procurement_display_id,
            minWidth: "120px",
        },
        {
            name: "Product Type / Frame /Glass Size/Power",
            selector: (row: TableData) =>
                `${row?.product?.product_type?.name}
         ${findConstantLabel(
                    constant?.PRODUCT_RIM_TYPE,
                    row?.product?.rim_type
                )}
         ${row?.product?.glass_size}`,
            minWidth: "120px",
        },
        {
            name: "Date Time",
            selector: (row: TableData) =>
                `${row?.createdAt
                    ? moment(row?.updatedAt).format("DD/MM/YYYY , H:mm:ss")
                    : "--"
                }`,
            sortable: true,
            minWidth: "120px",
        },
        {
            name: "Cover Photo",
            cell: (row: any) => (
                <CustomImages
                    src={row?.product?.images?.length > 0 && row?.product?.images[0]}
                    imageHeight={'50px'}
                />
            ),
            center: true,
            minWidth: "120px",
        },
        {
            name: "Requested Store Name",
            selector: (row: TableData) => row.requested_store.store_location || "-",
            minWidth: "200px",
        },
        {
            name: "Pickup Store",
            selector: (row: TableData) => row?.pickup_store?.store_location || "-",
            minWidth: "200px",
        },
        {
            name: "Order ID/Warranty Claim ID",
            selector: (row: any) =>
                row?.order?.order_id_display
                    ? row?.order?.order_id_display
                    : row?.warranty_claimed_product?.claim_id,
            minWidth: "140px",
        },
        {
            name: "Status",
            selector: (row: TableData) => row?.status || "-",
            minWidth: "150px",
        },
    ];

    return (
        <div>
            <div className="row align-items-center">
                <div className="col-6">
                    <Search
                        searchCallBack={(e: string) => {
                            setSearch(e);
                        }}
                    />
                </div>
            </div>
            <div>
                <Table
                    AdditionalClassName="add-invertory-table"
                    className="inventory-product-border"
                    columns={columns}
                    data={processListing?.data?.map((item: any) => {
                        return {
                            ...item,
                            status:
                                item.status === constant.MOVEMENT_STATUS.PICKUP ? (
                                    <div className="background-light-yellow border-product-radius">
                                        <p className="color-yellow m-1 p-1">{"Picked Up"}</p>
                                    </div>
                                ) : item.status === constant.MOVEMENT_STATUS.DELIVER ? (
                                    <div className="background-light-red border-product-radius">
                                        <p className="color-red m-1 p-1">{"To be Delivered"}</p>
                                    </div>
                                ) : (
                                    ""
                                ),
                        };
                    })}
                />
            </div>
            <div>
                <Pagination
                    totalCount={processListing?.count}
                    currentPage={currentPage}
                    totalPages={processListing?.totalPages}
                    onChangePage={(page: any) => setCurrentPage(page)}
                    setLimit={(e: number) => setLimitPerPage(e)}
                    limit={limit}
                />
            </div>
        </div>
    );
};

export default Index;
